
frappe.ui.form.ControlHeading = class BondControlHeading extends frappe.ui.form.ControlHTML{
	get_content() {
		return "<h4>" + __(this.df.label) + "</h4>";
	}
}
